<template>
  <div>
    <b-card class="md-3" style="min-height: 410px">
      <!-- Titulo de la seccion-->
      <b-row>
        <b-col class="align-left">
          <p style="padding-left: 40px">Instalación inicial</p>
        </b-col>
      </b-row>

      <!-- Formulario de adicion de nodos -->

      <!-- Formulario de adicion de nodos -->
      <div id="formulario-nodos" style="width: 100%">
        <!-- INIT FORMULARIO DE ADICION -->
        <b-form>
          <div class="groupBox">
            <b-row>
              <b-col>
                <!-- Fila 1 -->
                <b-row>
                  <b-col>
                    <b-button
                      class="w-100 h-100"
                      type="submit"
                      name="resetPanel"
                      id="resetPanel"
                      variant="danger"
                      size="sm"
                      @click="resetPanel"
                    >
                      <i class="fas fa-file-import"></i>
                      <span
                        class="text-uppercase"
                        style="
                          font-size: 12px;
                          font-weight: bold;
                          margin-left: 5px;
                        "
                        >Restaurar valores por defecto*</span
                      >
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button
                      class="w-100 h-100"
                      type="submit"
                      name="deleteDatagrams"
                      id="deleteDatagrams"
                      variant="warning"
                      size="sm"
                      @click="deleteDatagrams"
                    >
                      <i class="far fa-calendar-times"></i>
                      <span
                        class="text-uppercase"
                        style="
                          font-size: 12px;
                          font-weight: bold;
                          margin-left: 5px;
                        "
                        >Eliminar datagramas de la BBDD</span
                      >
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button
                      class="w-100 h-100"
                      type="submit"
                      name="deleteAlerts"
                      id="deleteAlerts"
                      variant="info"
                      size="sm"
                      @click="deleteAlerts"
                    >
                      <i class="far fa-bell-slash"></i>
                      <span
                        class="text-uppercase"
                        style="
                          font-size: 12px;
                          font-weight: bold;
                          margin-left: 5px;
                        "
                        >Eliminar alertas de la BBDD</span
                      >
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button
                      class="w-100 h-100"
                      type="submit"
                      name="downloadUndecoded"
                      id="downloadUndecoded"
                      variant="success"
                      size="sm"
                      @click="downloadUndecoded"
                    >
                      <i class="fas fa-download"></i>
                      <span
                        class="text-uppercase"
                        style="
                          font-size: 12px;
                          font-weight: bold;
                          margin-left: 5px;
                        "
                        >Descargar tramas NO decodificadas</span
                      >
                    </b-button>
                  </b-col>
                </b-row>

                <!-- Separador entre filas -->
                <b-row style="margin-top: 30px"> </b-row>

                <!-- FIn filas -->
                <b-row>
                  <b-col></b-col>
                  <b-col>
                    <b-button
                      class="w-100 h-100"
                      type="submit"
                      name="exportDatabase"
                      id="exportDatabase"
                      variant="dark"
                      size="sm"
                      @click="triggerDump"
                    >
                      <i class="fas fa-arrow-alt-circle-down"></i>
                      <span
                        class="text-uppercase"
                        style="
                          font-size: 12px;
                          font-weight: bold;
                          margin-left: 5px;
                        "
                        v-if="isDownloading"
                        >Descargando... {{ DumpProgressBar }} Mb</span
                      >
                      <span
                        v-else
                        class="text-uppercase"
                        style="
                          font-size: 12px;
                          font-weight: bold;
                          margin-left: 5px;
                        "
                        >Exportar BBDD completa</span
                      >
                    </b-button>
                  </b-col>
                  <b-col id="importFile">
                    <b-form-file
                      class="w-100 h-100"
                      placeholder="Elija un archivo o arrastrelo"
                      browse-text="Elegir"
                      name="fileDB"
                      size="sm"
                      v-model="fileDB"
                      :state="Boolean(fileDB)"
                    >
                      <i class="fas fa-arrow-alt-circle-down"></i>
                    </b-form-file>
                  </b-col>
                  <b-col></b-col>
                </b-row>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col>
                <small><strong>*RESTAURAR VALORES POR DEFECTO:</strong></small
                ><br />
                <small>
                  &nbsp;&nbsp;&nbsp; Recarga datos estáticos del proyecto pero
                  <strong>NO</strong> elimina información</small
                ><br />
                <small>
                  &nbsp;&nbsp;&nbsp; de zonas, sensores, medidas, nodos, grupos,
                  tramas y datagramas</small
                >
              </b-col>
            </b-row>
          </div>
        </b-form>
        <!-- END FORMULARIO DE ADICION -->
      </div>

      <!-- Formulario de adicion de nodos -->
    </b-card>
  </div>
</template>

<script>
import PanelConfigService from "@/services/PanelConfigService";
import DatagramService from "@/services/DatagramService";
import DataService from "@/services/DataService";
import DownloadService from "@/services/DownloadService";

export default {
  data() {
    return {
      fileDB: undefined,
      isDownloading: false,
      DumpProgressBar: 0,
    };
  },
  watch: {
    fileDB: function (val) {
      if (val == undefined) {
        return false;
      } else {
        return this.importDatabase();
      }
    },
  },
  methods: {
    // Agregar roles usuario y administrador a la bbdd
    resetPanel(e) {
      e.preventDefault();

      PanelConfigService.forceInstall()
        .then((response) => {
          return alert(
            response.data.message
              ? response.data.message
              : "Instalación de valores por defecto con éxito"
          );
        })
        .catch((error) => {
          return alert(
            error.data
              ? error.data.message
              : "Error instalando valores por defecto en bbdd"
          );
        });
    },

    updateProgressbar() {
      this.DumpProgressBar = sessionStorage.getItem("DumpProgressbar");
    },

    triggerDump(e) {
      e.preventDefault();

      if (!this.isDownloading) {
        this.isDownloading = true;
        let refreshIntervalId = setInterval(this.updateProgressbar, 100);
        this.exportDatabase().then(() => {
          this.isDownloading = false;
          clearInterval(refreshIntervalId);
        });
      }
    },

    deleteDatagrams(e) {
      e.preventDefault();

      DatagramService.deleteAll()
        .then((response) => {
          return alert(
            response.data.message
              ? response.data.message
              : "Valores de la BBDD limpiados con éxito"
          );
        })
        .catch((error) => {
          return alert(
            error.data
              ? error.data.message
              : "Error limpiando los datagramas en la BBDD"
          );
        });
    },

    async exportDatabase() {
      await PanelConfigService.exportDB()
        .then(async (response) => {
          //Download Files
          var data = new Blob([response.data]);
          var url = window.URL.createObjectURL(data);

          var link = document.createElement("a");
          var filename = response.headers["content-disposition"]
            .split("filename=")[1]
            .split(";")[0];
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          document.body.appendChild(link); // Required for FF

          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {});
    },

    async importDatabase() {
      const files = this.fileDB;

      //Si hay ficheros
      if (files) {
        const formData = new FormData();
        formData.append("fileDB", files);

        await PanelConfigService.importDB(formData)
          .then((response) => {
            alert(
              response.data.message
                ? response.data.message
                : "Información completa de la BBDD importada con éxito"
            );
            return this.$router.push({ name: "logout" });
          })
          .catch((error) => {
            return alert(
              error.data
                ? error.data.message
                : "Error importando la información completa de la BBDD"
            );
          });
      }
    },

    deleteAlerts(e) {
      e.preventDefault();

      DataService.deleteAllAlarms()
        .then((response) => {
          return alert(
            response.data.message
              ? response.data.message
              : "Valores de la BBDD limpiados con éxito"
          );
        })
        .catch((error) => {
          return alert(
            error.data
              ? error.data.message
              : "Error limpiando las alertas en la BBDD"
          );
        });
    },

    downloadUndecoded(e) {
      e.preventDefault();

      DownloadService.downloadUndecodedDatagram()
        .then((response) => {
          return alert(
            response.data.message
              ? response.data.message
              : "Se han descarga las tramas NO decodificadas"
          );
        })
        .catch((error) => {
          return alert(
            error.data
              ? error.data.message
              : "Error al intentar descargar las tramas NO decodificadas"
          );
        });
    },
  },
};
</script>




<style scoped>
/* OTHER STYLES*/
/**************/
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
  margin-left: 30px;
  margin-right: 30px;
}

.innergroupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#importFile {
  cursor: pointer;
}
</style>
<style>
.custom-file-label::after {
  cursor: pointer;
}
</style>